import classNames from 'classnames';
import * as React from 'react';
import { ReactNode } from 'react';

import '../../../styles/PackagesInput.scss';

interface IProps {
  options: any;
  onChange: any;
  selected: any;
  labels: {
    quantity: string | ReactNode;
    duration: string | ReactNode;
    target: string | ReactNode;
    cost: string | ReactNode;
  };
}

interface IState {
  selected: any;
}

export class PackagesInput extends React.Component<IProps, IState> {
  constructor(props?: any, context?: any) {
    super(props, context);
    this.state = {
      selected: null,
    };
  }

  handleOnChange = (e, keypress?) => {
    const value = e.target.value;
    this.props.onChange && this.props.onChange(value);
  };

  checked = (option) => {
    const { selected } = this.props;
    return selected === option.value;
  };

  render() {
    const { options, labels } = this.props;
    return (
      <div className='packages-input'>
        {!!options &&
          options.map((option, idx) => {
            const checked = this.checked(option);

            return (
              <label
                htmlFor={'packages-input-option-' + idx}
                className={classNames('packages-input-label', {
                  checked: checked,
                })}
              >
                <div className='packages-input-title'>{option.title}</div>

                <div className='packages-input-subtitle'>
                  {labels.quantity}
                  {/*<FormattedMessage id="ec.components.packages.quantity" defaultMessage="Anzahl Flächen" />*/}
                </div>

                <div className='packages-input-row'>
                  <div className='packages-input-col-left'>
                    <div className='packages-input-number'>{option.quantity}</div>
                  </div>

                  <div className='packages-input-col-right'>
                    <div className='packages-input-light-text'>
                      {option.countcategories.map((count) => (
                        <p className='mb-0'>{count}</p>
                      ))}
                    </div>
                  </div>
                </div>
                <div className='packages-input-row'>
                  <div className='packages-input-col-left'>
                    {labels.duration}
                    {/*<FormattedMessage id="ec.components.packages.duration" defaultMessage="Präsenz" />*/}
                  </div>

                  <div className='packages-input-col-right'>{option.duration}</div>
                </div>

                <div className='packages-input-row'>
                  <div className='packages-input-col-left'>
                    {labels.target}
                    {/*<FormattedMessage id="ec.components.packages.target" defaultMessage="Zielgebiet" />*/}
                  </div>

                  <div className='packages-input-col-right'>{option.target}</div>
                </div>

                <div className='packages-input-row'>
                  <div className='packages-input-col-left'>
                    {labels.cost}
                    {/*<FormattedMessage id="ec.components.packages.cost" defaultMessage="Kosten" />*/}
                  </div>

                  <div className='packages-input-col-right'>{`CHF ${option.cost}`}</div>
                </div>

                <input
                  type='radio'
                  value={option.value}
                  className='packages-input-input'
                  id={'packages-input-option-' + idx}
                  checked={checked}
                  onChange={(e) => this.handleOnChange(e)}
                  onKeyPress={(e) => {
                    var code = e.keyCode || e.which;

                    if (code === 13) {
                      this.handleOnChange(e, true);
                    }
                  }}
                />
              </label>
            );
          })}
      </div>
    );
  }
}
